import { toast as hotToast, type ToastOptions as HotToastOptions } from 'react-hot-toast'

import { createProgress } from './createProgress'
import { CustomToast } from './CustomToast'

export type ToastOptions = Partial<Pick<HotToastOptions, 'duration' | 'position'>>

export const toast = {
    error: (message: string, options?: ToastOptions) =>
        hotToast.custom((toast) => <CustomToast severity="error" toast={toast} message={message} />, {
            ...options,
        }),
    success: (message: string, options?: ToastOptions) =>
        hotToast.custom((toast) => <CustomToast severity="success" toast={toast} message={message} />, {
            ...options,
        }),
    remove: (toastId: string) => hotToast.remove(toastId),
    createProgress,
}
